import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { UIRouterModule } from "@uirouter/angular";
import { ComponentModule } from "../components/components.module";
import { ModalModule } from "../modals/modal.module";
import { PipesModule } from "../pipes/pipes.module";
import { ServiceModule } from "../services/service.module";
import { ComplianceItemActionButtonComponent } from "./components/compliance-item-action-button/compliance-item-action-button.component";
import { ComplianceReminderFilterPipe } from "./pipes/compliance-reminder-filter.pipe";
import { MonthDayDisplayPipe } from "./pipes/month-day-display/month-day-display.pipe";
import { MonthDisplayPipe } from "./pipes/month-display.pipe";
import { RecurrenceSummaryPipe } from "./pipes/recurrence-summary.pipe";
import { WeekdayDisplayPipe } from "./pipes/weekday-display.pipe";
import { WeekdayIntervalDisplayPipe } from "./pipes/weekday-interval-display.pipe";
import { StatusIndicatorComponent } from "./components/status-indicator/status-indicator.component";
import { ComplianceItemsListComponent } from "./components/compliance-items-list/compliance-items-list.component";
import { ComplianceItemSummaryComponent } from "./components/compliance-item-summary/compliance-item-summary.component";
import { EdlCommonComponentsModule, EdlCommonDirectiveModule, EdlCommonPipesModule } from "@edl-development/edl-common";
import { ComplyDirectivesModule } from "../directives/comply-directives.module";
import { ItemPacketsCommonModule } from "../item-packets/common/item-packets-common.module";
import { CplRosterActionsComponent } from './components/cpl-roster-actions/cpl-roster-actions.component';
import { ComplianceItemEvidenceComponent } from './components/compliance-item-evidence/compliance-item-evidence.component';
import { CplA48StatusIndicatorComponent } from './components/cpl-a48-status-indicator/cpl-a48-status-indicator.component';
import { EdlTimeTrackingModule } from "../time-tracking/time-tracking.module";
import { EdlIconModule } from "../components/edl-icon/edl-icon.module";

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(),
        EdlCommonDirectiveModule,
        ComplyDirectivesModule,
        ModalModule,
        EdlCommonPipesModule,
        PipesModule,
        NgbModule,
        ReactiveFormsModule,
        FormsModule,
        ServiceModule,
        ComponentModule,
        EdlCommonComponentsModule,
        ItemPacketsCommonModule,
        EdlTimeTrackingModule,
        EdlIconModule
    ],
    declarations: [
        CplA48StatusIndicatorComponent,
        CplRosterActionsComponent,
        ComplianceItemActionButtonComponent,
        ComplianceItemEvidenceComponent,
        ComplianceItemSummaryComponent,
        ComplianceItemsListComponent,
        StatusIndicatorComponent,
        ComplianceReminderFilterPipe,
        RecurrenceSummaryPipe,
        MonthDisplayPipe,
        WeekdayIntervalDisplayPipe,
        MonthDayDisplayPipe,
        WeekdayDisplayPipe
    ],
    exports: [
        CplA48StatusIndicatorComponent,
        CplRosterActionsComponent,
        ComplianceItemActionButtonComponent,
        ComplianceItemEvidenceComponent,
        ComplianceItemsListComponent,
        ComplianceItemSummaryComponent,
        StatusIndicatorComponent,
        ComplianceReminderFilterPipe,
        RecurrenceSummaryPipe,
        MonthDisplayPipe,
        WeekdayIntervalDisplayPipe,
        MonthDayDisplayPipe,
        WeekdayDisplayPipe
    ]
})
export class SharedComplianceItemsModule { }
